import { FovModel } from './../model';
import {
  Boundingbox2Controller,
  BoundingBox2FromCenterSize,
  BoundingBox2FromLRTB,
} from './../share/boundingbox2';
import { EntityStoreService } from './../../entity-store/entity-store.service';
import { MultiCanvasService } from './../../multi-canvas/multi-canvas.service';
import { Vector2, Vector3 } from 'three';
import { EventDistributeService, EventHandler, FovHandler } from './event-distribute.service';
import { Subject } from 'rxjs';
import { MouseCanvasService } from './../controls/mouse/mouse-canvas.service';
import { CanvasService } from './../components/canvas.service';

import { Component, OnInit, Output, EventEmitter, Input, AfterContentInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { RingModel } from '../model';
export interface Fovs {
  fov1: BoundingBox2FromCenterSize;
  fov2: BoundingBox2FromCenterSize;
  fov3: BoundingBox2FromCenterSize;
}
@Component({
  selector: 'ng3-event-distribute',
  templateUrl: './event-distribute.component.html',
  styleUrls: ['./event-distribute.component.css'],
})
export class EventDistributeComponent implements OnInit, AfterContentInit {
  stop = new Subject<void>();
  @Output() fovs = new EventEmitter<Fovs>();
  readonly domElement = this.canvasService.domElement;
  // readonly eventHandler = this.distribution.eventHandler;
  // readonly fovHandler = this.distribution.fovHandler;
  @Input() eventHandler: EventHandler = {
    ring: { enable: false, tag: 'drag' },
    line: { enable: false, tag: 'drag' },
    crossline: { enable: false, tag: 'drag' },
    fov: { enable: true, tag: 'stop drag' },
  };
  @Input() fovHandler: FovHandler = {
    fov1: { enable: false, tag: 'drag' },
    fov2: { enable: false, tag: 'drag' },
    fov3: { enable: false, tag: 'drag' },
    };
  @Input() entityStore;
  @Input() multiCanvas;
    private crossline = new CrosslineController(
    this.eventHandler.crossline.enable,
    this.multiCanvas,
    this.entityStore,
  );
  private fov: FovController;
  private ring = new RingContrller(
    this.eventHandler.ring.enable,
    this.multiCanvas,
    this.entityStore,
  );
  constructor(
    private canvasService: CanvasService,
    private mouse: MouseCanvasService,
    // private multiCanvas: MultiCanvasService,
    // private entityStore: EntityStoreService,
  ) {
    this.mouse.downWithButton$.pipe(takeUntil(this.stop)).subscribe(e => {
      e.original.preventDefault();
      if (this.eventHandler.crossline.enable) {
        this.crossline.activate();
        this.crossline.onMouseDown(e.position);
      }
      if (this.eventHandler.ring.enable) {
        this.ring.activate();
        this.ring.onMouseDown(e.position);
      }
      if (this.eventHandler.fov.enable) {
        this.fov.activate();
        this.fov.onMouseDown(e.position, this.fovHandler);
      }
    }, console.error);
    this.mouse.position$.pipe(takeUntil(this.stop)).subscribe(e => {
      this.crossline.onMouseMove(e);
      this.ring.onMouseMove(e);
      this.fov.onMouseMove(e);
      let fovsV = {
        fov1: this.fov.fovs[0],
        fov2: this.fov.fovs[1],
        fov3: this.fov.fovs[2],
      };

      this.fovs.emit(fovsV);
    }, console.error);
    this.mouse.up$.pipe(takeUntil(this.stop)).subscribe(e => {
      this.crossline.deactivate();
      this.ring.deactivate();
      this.fov.deactivate();
    }, console.error);
    // this.mouse.wheel$
    //   .pipe(takeUntil(this.stop))
    //   .subscribe(e => console.log('wheel', e), console.error);
    // this.mouse.leave$
    //   .pipe(takeUntil(this.stop))
    //   .subscribe(e => console.log('leave', e), console.error);
  }

  ngOnInit() {}
  ngAfterContentInit(): void {
    this.fov = new FovController(
      this.eventHandler.fov.enable,
      this.multiCanvas,
      this.entityStore,
    );
    this.crossline = new CrosslineController(
      this.eventHandler.crossline.enable,
      this.multiCanvas,
      this.entityStore,
    );
    this.ring = new RingContrller(
      this.eventHandler.ring.enable,
      this.multiCanvas,
      this.entityStore,
    );
  }
}

class MouseController {
  private _activated = false;
  protected origin = new Vector2();
  protected start = new Vector2();
  protected end = new Vector2();
  protected delta = new Vector2();
  protected delta2 = new Vector2();
  protected boxController: Boundingbox2Controller;
  get activated() {
    if (this.eventEnbable) {
    }
    return this._activated;
  }
  activate() {
    this._activated = true;
  }
  deactivate() {
    this._activated = false;
  }
  constructor(
    public eventEnbable: boolean, // private multiCanvas: MultiCanvasService, // private entityStore: EntityStoreService,
  ) {}
  // onMouseDown(position: Vector2) {
  //   if (this.activated) {
  //     this.start.set(position.x, position.y);
  //     this.origin.set(position.x, position.y);
  //   }
  // }
  onMouseUp() {
    this.deactivate();
  }
}
export class FovController extends MouseController {
  private onBox = 'inside';
  private fovHandler: FovHandler;
  private activeFov: number;
  public fovs = [
    new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(20, 20)),
    new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(20, 20)),
    new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(20, 20)),
  ];
  constructor(
    eventEnable: boolean,
    private multiCanvas: MultiCanvasService,
    private entityStore,
  ) {
    super(eventEnable);
  }
  onMouseWheel() {}
  onMouseDown(position: Vector2, fovHandler: FovHandler) {
    if (this.activated) {
      this.start.set(position.x, position.y);
      this.origin.set(position.x, position.y);
    }
    this.fovHandler = fovHandler;
    let i = 0;
    if (fovHandler.fov3.enable) {
      i = 2;
    }
    if (fovHandler.fov2.enable) {
      i = 1;
    }
    if (fovHandler.fov1.enable) {
      i = 0;
    }

    this.multiCanvas.mapSelectedCanvas(c => {
      this.entityStore.fovsOnCanvas(c, fovs => {
        if (fovs[i] === undefined) {
          return;
        }
        this.boxController = new Boundingbox2Controller(
          (fovs[i].model as FovModel).box,
          0.1,
        );
        this.onBox = this.boxController.onWhichAreabox(position);
      });
    });
  }
  onMouseMove(position: Vector2) {
    if (!this.activated) {
      return;
    }
    this.end.set(position.x, position.y);
    this.delta.subVectors(this.end, this.start);
    this.delta2.subVectors(this.end, this.origin);
    // this.boxController = new Boundingbox2Controller(
    //   new BoundingBox2FromCenterSize(this.origin, new Vector2(20, 20)),
    //   0.1,
    // );
    // this.dragFov(this.start);
    if (this.fovHandler.fov1.enable) {
      this.fovEvent(this.origin, this.delta, this.end, 0);
    }
    if (this.fovHandler.fov2.enable) {
      this.fovEvent(this.origin, this.delta, this.end, 1);
    }
    if (this.fovHandler.fov3.enable) {
      this.fovEvent(this.origin, this.delta, this.end, 2);
    }
    // this.fovEvent(this.origin, this.delta, this.delta2, 0);
    this.start.copy(this.end);
  }
  dragFov(current: Vector2) {
    this.multiCanvas.mapSelectedCanvas(c => {
      this.entityStore.fovOnCanvas(c, fov => {
        // console.log(current, fov.box.size);
        this.entityStore.updateFov({
          id: fov.id,
          model: {
            ...(fov.model as FovModel),
            box: new BoundingBox2FromCenterSize(
              current,
              (fov.model as FovModel).box.size,
            ),
          },
        });
      });
    });
  }
  fovEvent(origin: Vector2, delta: Vector2, current: Vector2, i: number) {
    this.multiCanvas.mapSelectedCanvas(c => {
      this.entityStore.fovsOnCanvas(c, fovs => {
        if (fovs[i] === undefined) {
          return;
        }
        // this.entityStore.fovOnCanvas(c, fovS => {
        // console.log(current, fov.box.size);
        // this.boxController = new Boundingbox2Controller(fov.box, 0.1);
        // console.log('fovs', fovs[i]);

        let fov = fovs[i].model as FovModel;
        this.fovs[i] = fov.box as BoundingBox2FromCenterSize;

        // let current = new Vector2();
        // let scale = new Vector2(10, 10);
        // console.log(delta2);
        // delta2.sub(scale);
        // console.log(delta2);
        // current.addVectors(fov.box.center, delta2);
        // console.log(current);
        switch (this.onBox) {
          case 'inside': // drag
            this.entityStore.updateFov({
              id: fovs[i].id,
              model: {
                ...fov,
                box: new BoundingBox2FromCenterSize(current, fov.box.size),
              },
            });
            break;
          case 'left': // resize
            this.entityStore.updateFov({
              id: fovs[i].id,
              model: {
                ...fov,
                box: new BoundingBox2FromLRTB(
                  fov.box.left + delta.x,
                  fov.box.right,
                  fov.box.top,
                  fov.box.bottom,
                ),
              },
            });
            break;
          case 'right':
            this.entityStore.updateFov({
              id: fovs[i].id,
              model: {
                ...fov,
                box: new BoundingBox2FromLRTB(
                  fov.box.left,
                  fov.box.right + delta.x,
                  fov.box.top,
                  fov.box.bottom,
                ),
              },
            });
            break;
          case 'top':
            this.entityStore.updateFov({
              id: fovs[i].id,
              model: {
                ...fov,
                box: new BoundingBox2FromLRTB(
                  fov.box.left,
                  fov.box.right,
                  fov.box.top + delta.y,
                  fov.box.bottom,
                ),
              },
            });
            break;
          case 'bottom':
            this.entityStore.updateFov({
              id: fovs[i].id,
              model: {
                ...fov,
                box: new BoundingBox2FromLRTB(
                  fov.box.left,
                  fov.box.right,
                  fov.box.top,
                  fov.box.bottom + delta.y,
                ),
              },
            });
            break;
          case 'none':
            break;
        }
      });
    });
  }
}
export class CrosslineController extends MouseController {
  constructor(
    eventEnable: boolean,
    private multiCanvas: MultiCanvasService,
    private entityStore: EntityStoreService,
  ) {
    super(eventEnable);
  }
  onMouseDown(position: Vector2) {
    if (this.activated) {
      this.start.set(position.x, position.y);
      this.origin.set(position.x, position.y);
    }
  }
  onMouseWheel() {}
  onMouseMove(position: Vector2) {
    if (!this.activated) {
      return;
    }
    // console.log(this.start);
    this.end.set(position.x, position.y);
    this.delta.subVectors(this.end, this.start);
    // console.log(this.multiCanvas.componentCanvasSubject.value);
    // console.log(this.multiCanvas.selectedSubject.value);
    // this.multiCanvas.mapSelectedCanvas(c => console.log(c));
    this.dragCrossline(this.start);
    this.start.copy(this.end);
  }
  dragCrossline(current: Vector2) {
    // console.log(this.multiCanvas);
    this.multiCanvas.mapSelectedCanvas(c => {
      if (c !== undefined) {
        this.entityStore.crosslineOnCanvas(c, crossline => {
          if (crossline === undefined) {
            return;
          }
          let position: Vector3;
          switch (crossline.view) {
            case 'x':
              position = new Vector3(
                crossline.position.x,
                current.x,
                current.y,
              );
              break;
            case 'y':
              position = new Vector3(
                current.x,
                crossline.position.y,
                current.y,
              );
              break;
            case 'z':
              position = new Vector3(
                current.x,
                current.y,
                crossline.position.z,
              );
              break;
            default:
          }
          this.entityStore.updateCrosslines({
            model: {
              ...crossline,
              position: position,
            },
          });
          // this.entityStoreService.updateCrosslineEntity({
          //   canvasId: c,
          //   model: {
          //     ...crossline,
          //     position: position,
          //   },
          // });
        });
      }
    });
  }
}
export class RingContrller extends MouseController {
  private onBox = 'inside';
  constructor(
    eventEnable: boolean,
    private multiCanvas: MultiCanvasService,
    private entityStore: EntityStoreService,
  ) {
    super(eventEnable);
  }
  onMouseDown(position: Vector2) {
    if (this.activated) {
      this.start.set(position.x, position.y);
      this.origin.set(position.x, position.y);
    }
    this.multiCanvas.mapSelectedCanvas(c => {
      this.entityStore.ringOnCanvas(c, ring => {
        if (ring === undefined) {
          return;
        }
        this.boxController = new Boundingbox2Controller(
          new BoundingBox2FromCenterSize(
            new Vector2(ring.center.x, ring.center.y),
            new Vector2(ring.outerRadius * 2, ring.outerRadius * 2),
          ),
          0.1,
        );
        this.onBox = this.boxController.onWhichAreabox(position);
      });
    });
  }
  onMouseWheel() {}
  onMouseMove(position: Vector2) {
    if (!this.activated) {
      return;
    }
    this.end.set(position.x, position.y);
    this.delta.subVectors(this.end, this.origin);
    // this.ResizeRing(this.origin, this.delta);
    this.dragRing(this.origin, this.delta, this.end);
    this.start.copy(this.end);
  }
  dragRing(origin: Vector2, delta: Vector2, current: Vector2) {
    this.multiCanvas.mapSelectedCanvas(c =>
      this.entityStore.ringOnCanvas(c, ring => {
        switch (this.onBox) {
          case 'inside':
            this.entityStore.updateRingEntity({
              canvasId: c,
              model: {
                ...ring,
                center: new Vector3(current.x, current.y, 0),
              },
            });
            break;
          case 'left':
          case 'right':
          case 'top':
          case 'bottom':
          case 'none':
            const d = new Vector2();
            d.subVectors(new Vector2(ring.center.x, ring.center.y), current);
            const circleRadius = Math.sqrt(Math.pow(d.x, 2) + Math.pow(d.y, 2));
            this.entityStore.updateRingEntity({
              canvasId: c,
              model: new RingModel(
                new Vector3(ring.center.x, ring.center.y, 0),
                circleRadius,
                circleRadius + 0.001,
              ),
            });
            break;
        }
      }),
    );
  }
  ResizeRing(origin: Vector2, delta: Vector2) {
    this.multiCanvas.mapSelectedCanvas(c => {
      const circleRadius = Math.sqrt(
        Math.pow(delta.x, 2) + Math.pow(delta.y, 2),
      );
      this.entityStore.updateRingEntity({
        canvasId: c,
        model: new RingModel(
          new Vector3(origin.x, origin.y, 0),
          circleRadius,
          circleRadius + 0.001,
        ),
      });
    });
  }
}
